import {
    Page,
    usePromise,
} from "@keycloak/keycloak-account-ui";
import {
    PageSection,
    PageSectionVariants,
    Spinner,
    Text,
    TextContent,
    Title,
} from "@patternfly/react-core";
import {useState} from "react";
import { useTranslation } from "react-i18next";
import { useEnvironmentWithDonorService } from '../../context';
import type { IAMPersonalInfoJsonSchema } from "../../donor-service";
import {FORMAT_DATE_ONLY, formatDate} from "../../utils/formatDate.ts";
import {formatNumber} from "../../utils/formatNumber.ts";

type DonorInfosRepresentation = IAMPersonalInfoJsonSchema

export function OverviewPage () {
    const { t } = useTranslation();
    const context = useEnvironmentWithDonorService();

    const [donorInfos, setDonorInfos] = useState<DonorInfosRepresentation>();

    usePromise(
        async () => {
            const { personalInformation } = await context.donorService.fetchDonorRecord();
            return {...personalInformation};
        },
        setDonorInfos,
    );

    if (!donorInfos) {
        return <Spinner />;
    }

    const {
        donationAmountLastYear,
        donationAmountThisYear,
        lastDonationDate,
        membership,
        membershipExpiry,
    } = donorInfos;

    const niceAmountThisYear = donationAmountThisYear ? formatNumber(donationAmountThisYear) : undefined;
    const niceAmountLastYear = donationAmountLastYear ? formatNumber(donationAmountLastYear) : undefined;
    const niceExpiryDate = membershipExpiry && formatDate(new Date(membershipExpiry), context.environment.locale, FORMAT_DATE_ONLY);
    const niceLastDate = lastDonationDate && formatDate(new Date(lastDonationDate), context.environment.locale, FORMAT_DATE_ONLY);

    return (
        <Page title={t("overview")} description="">
            <PageSection variant={PageSectionVariants.light} padding={{ default: 'noPadding' }}>
                <TextContent>
                    <Title size="xl" headingLevel="h2">
                        {t("membership")}
                    </Title>
                    <Text>
                        {
                            membership
                                ? niceExpiryDate
                                    ? t('membershipTrueUntil', { date: niceExpiryDate })
                                    : t('membershipTrue')
                                : t('membershipFalse')
                        }
                    </Text>
                    {
                        niceLastDate || niceAmountThisYear || niceAmountLastYear
                            ? <Title size="xl" headingLevel="h2">{t("overviewOfDonations")}</Title>
                            : undefined
                    }
                    <Text>
                        {niceLastDate ? t('lastDateOfDonation', {date: niceLastDate}) : undefined}
                    </Text>
                    <Text>
                        {niceAmountThisYear ? t('thisYearDonation', {amount: niceAmountThisYear}) : undefined}
                    </Text>
                    <Text>
                        {niceAmountLastYear ? t('lastYearDonation', {amount: niceAmountLastYear}) : undefined}
                    </Text>
                </TextContent>
            </PageSection>
        </Page>
    );
}
